import axios from "axios";
import { base } from "../base";
import { getAttribution } from "../utils/attribution";

export const clientSignup = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/signup`,
		data: { ...data, attribution: getAttribution() },
	});
	return reponse;
};

export const clientVerifyOtp = async (otp) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/verify/otp`,
		data: {
			email: localStorage.getItem("email"),
			otp: otp,
		},
	});
	return reponse;
};

export const clientResendOtp = async () => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/resendotp`,
		data: {
			email: localStorage.getItem("email"),
		},
	});
	return reponse;
};

export const clientLogin = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/login`,
		data: data,
	});
	return response;
};

export const clientResetPass = async (data) => {
	const response = await axios({
		method: "PUT",
		url: `${base}/api/client/forgot-password`,
		data: data,
	});
	return response;
};

export const clientUpdatePass = async (data) => {
	const response = await axios({
		method: "PUT",
		url: `${base}/api/client/reset-password`,
		data: data,
	});
	return response;
};

export const clientUploadLogo = async (data, setProgress) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/upload/company/logo`,
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
		onUploadProgress: (progressEvent) =>
			setProgress(
				Math.round((progressEvent.loaded * 100) / progressEvent.total)
			),
	});
	return reponse;
};

export const companyInfo = async (data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/company/info`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return reponse;
};

export const companyInfoType = async (data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/company/type`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return reponse;
};

export const companyAdditionalInfo = async (data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/additional/info`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return reponse;
};

export const companyProfile = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/profile`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientAddNewJob = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/jobs/add`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return reponse;
};

export const getAllClientJobs = async (page = 1, jobStatus) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs`,
		params: {
			page: page,
			order: "desc",
			jobStatus: jobStatus,
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const getClientJobById = async (id) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/job/${id}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const getAllClientPostedJobs = async (page = 1) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/posted`,
		params: {
			page: page,
			order: "desc",
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const updateClientProfile = async (data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/client/info`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return reponse;
};

export const getAllJobsForTalent = async (page = 1) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/all`,
		params: {
			page: page,
			order: "desc",
		},
	});
	return reponse;
};

export const joinClientWaitlist = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/launch/register`,
		data: { ...data, attribution: getAttribution() },
	});
	return reponse;
};

export const jobApplicantsById = async (applicantId) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/applicants/job/${applicantId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const jobApplicants = async (page = 1, applicationStatus) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/applicants/`,
		params: {
			page: page,
			order: "desc",
			applicationStatus: applicationStatus,
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const matchedJobApplicants = async (page = 1, applicationStatus) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/matched-applicants/`,
		params: {
			page: page,
			order: "desc",
			applicationStatus: applicationStatus,
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const clientActiveJobs = async (page = 1, applicationStatus) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/applicants/`,
		params: {
			page: page,
			order: "desc",
			applicationStatus: applicationStatus,
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const talentJobProfile = async (applicantId) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/applicant/${applicantId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const previewRoleMatchCost = async (roleId) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/role-match-cost/${roleId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const previewMatchCost = async (applicantId) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/applicant/match-cost/${applicantId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const matchTalent = async (applicantId) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/applicant/match/${applicantId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const cancelMatchTalent = async (jobID, data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/applicant/cancel/${jobID}`,
		data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const completeJob = async (jobID, data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/complete/${jobID}`,
		data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const closeJob = async (jobID, data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/cancel/${jobID}`,
		data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const getMessages = async (data) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/messages`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientInfo = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/client_info`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return reponse;
};

export const getCancelledJob = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/cancelled`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const getCompletedJob = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/completed`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientGoogleLogin = async (data) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/google`,
		data: data,
	});
	return response;
};

export const clientFacebookLogin = async (data) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/facebook`,
		data: data,
	});
	return response;
};

export const clientLinkedinLogin = async (data) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/linkedin`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return response;
};

export const clientJobDrafts = async (data) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/jobs/draft`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return response;
};

export const subscriptionHistory = async (page = 1) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/subscription/`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		params: {
			page: page,
			order: "desc",
		},
	});
	return response;
};

export const postSubscription = async (id, data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/subscription/${id}/subscribe`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: { ...data, attribution: getAttribution() }
	});
	return response;
};

export const uploadClientProfilePhoto = async (id, data) => {
	const response = await axios({
		method: "PUT",
		url: `${base}/api/client/profile/upload/avatar/${id}/`,
		data: data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return response;
};

export const clientDeleteJob = async (id) => {
	const reponse = await axios({
		method: "DELETE",
		url: `${base}/api/client/jobs/delete/${id}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientChangePassword = async (data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/change/password`,
		data: data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientStartTrial = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/subscription/trial/start`,
		data: data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientCheckTrial = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/subscription/trial/status`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientCreateOrGetConversation = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/conversations/client`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
		data: {
			participantEmail: data.participantEmail,
			subject: data.subject,
		},
	});
	const conv = response.data?.data?.data || response.data?.data || response.data;
	if (!conv?._id) {
		return ('Invalid conversation response structure');
	}
	return response.data;
};

export const clientSendMessage = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/messages/client`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
		data: {
			conversationId: data.conversationId,
			receiverEmail: data.receiverEmail,
			content: data.content,
		},
		timeout: 10000,
	});
	return response.data;
};

export const clientGetConversations = async (page = 1, limit = 6, search = '') => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/conversations/client`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
		params: {
			page,
			limit,
			...(search ? { search } : {}),
		},
	});
	return response;
};

export const clientGetMessages = async (conversationId, page = 1, limit = 20) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/messages/client`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
		params: {
			conversationId: conversationId,
			page: page,
			limit: limit,
		},
	});

	const messages = response.data?.data?.messages || response.data?.messages;
	if (!messages) {
		return ('Invalid messages response structure');
	}

	return response.data;
};

export const clientMarkMessageAsRead = async (messageId) => {
	const response = await axios({
		method: "PUT",
		url: `${base}/api/messages/${messageId}/read`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return response;
};

export const clientDeleteConversation = async (conversationId) => {
	const response = await axios({
		method: "DELETE",
		url: `${base}/api/conversations/client/${conversationId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
	});
	return response;
};

export const clientDeleteMessage = async (messageId) => {
	const response = await axios({
		method: "DELETE",
		url: `${base}/api/messages/client/${messageId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
	});
	return response;
};

export const clientUpdateMessageStatus = async (messageId, status) => {
	const response = await axios({
		method: "PATCH",
		url: `${base}/api/messages/client/${messageId}/status`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
		data: {
			status: status,
		},
	});
	return response;
};

export const clientAnalytics = async (data) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/analytics/activity`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: data,
	});
	return response;
};

export const reportHireLeft = async (applicantId, reason) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/applicant/left/${applicantId}`,
		data: { reason },
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientCancelMatch = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/jobs/cancel-match`,
		data: data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const advancedClientSearch = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/clients/search/advanced`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getNotifications = async (page = 1, limit = 10) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/notifications?page=${page}&limit=${limit}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return response;
};


export const clientUpdateJob = async (id, data) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/update/${id}`,
		data: data,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientSearchTalents = async (page = 1, filter) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/searchTalents`,
		params: {
			page: page,
			...filter
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientGetSearchTalent = async (id) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/selectTalent/${id}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const clientGetShortlistedTalents = async (page = 1, limit = 10) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/shortlist/`,
		params: {
			page: page,
			limit: limit,
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};
export const clientViewShortlist = async (id) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/shortlist/${id}/`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientAddShortlistTalent = async (id) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/client/shortlistTalent/${id}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientRemoveShortlistTalent = async (id) => {
	const reponse = await axios({
		method: "DELETE",
		url: `${base}/api/client/shortlistTalent/${id}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientActiveSubscription = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/three-in-one/`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const postSupportComplaint = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/client/support`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  });

  return response;
};

export const getSupportComplaints = async (page = 1, limit = 10) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/client/support?page=${page}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return response;
};

export const getSupportComplaintById = async (id) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/client/support/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

	return response;
};

export const replySupportComplaint = async (id, data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/support/reply/${id}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
			"Content-Type": "application/json",
		},
		data,
	});
	return response;
};

export const getNotificationById = async (notificationID) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/notifications/${notificationID}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return response;
};

export const clientGetAnonymizedCV = async (id) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/get-resume/${id}`,
		responseType: 'blob',
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientMatchRandomTalent = async (jobId, talentId) => {
	const reponse = await axios({
		method: "PUT",
		url: `${base}/api/client/jobs/randomtalent/match/${jobId}/${talentId}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientGetTemplate = async (id) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/template`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientGetActiveSubscriptions = async (id) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/active-subscriptions`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const findClientSubscription = async (data) => {
	const reponse = await axios({
		method: "POST",
		url: `${base}/api/subscription/find`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data,
	});
	return reponse;
};
export const clientSubscriptionPlans = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/subscription/client/subscriptionplans`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientSubscribeToPlan = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/subscription/client/subscribe`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: { ...data, attribution: getAttribution() }
	});
	return response;
};

export const clientSubscribeToPlanSignupCheckout = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/signup-checkout`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: { ...data, attribution: getAttribution() }
	});
	return response;
};

export const getClientCurrentSubscription = async () => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/subscription/client/current`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

export const clientGetRoles = async ({ page = 1, limit = 30 }) => {
	const reponse = await axios({
		method: "GET",
		url: `${base}/api/client/roles`,
		params: {
			page: page,
			limit: limit,
		},
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return reponse;
};

/**
 * @typedef {Object} Job
 * @property {string} _id
 * @property {string} clientId
 * @property {string} jobType
 * @property {string} title
 * @property {string} budget
 * @property {string} startDate
 * @property {string} endDate
 * @property {string} duration
 * @property {string} type
 * @property {string} workMode
 * @property {string} description
 * @property {string} location
 * @property {string} language
 * @property {string} objectives
 * @property {string} acceptanceCriteria
 * @property {string} responsibilities
 * @property {string[]} skillsAndRequirements
 * @property {string} longTermJob
 * @property {string} provideOneMonthNotice
 * @property {string} hasNoRelocationPlans
 * @property {string} jobStatus
 * @property {string} status
 * @property {number} __v
 * @property {string} createdAt
 * @property {string} updatedAt
 */

/**
 * @typedef {Object} SearchResponse
 * @property {string} status
 * @property {{ jobs: Job[] }} data
 * @typedef {('title' | 'jobType' | 'type' | 'description' | 'location' | 'skillsAndRequirements' | 'paymentFee' | 'startDate' | 'endDate' | 'objectives')} Field
 */

/**
 * Makes a POST request to the /advance/search endpoint.
 *
 * @param {string} query - The search query string.
 * @param {Field[]} fields - Array of fields to query.
 * @returns {Promise<import('axios').AxiosResponse<SearchResponse>>} - The response from the server.
 */
export const searchAdvance = async (query, fields, startDate) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/advance/search`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
		data: {
			query: query,
			fields: fields,
			startDate,
		},
	});

	return response;
};

export const markNotificationAsRead = async (notificationID) => {
	const response = await axios({
		method: "GET",
		url: `${base}/api/notifications/${notificationID}`,
		headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		},
	});
	return response;
};



const authHeaders = () => ({
	Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ─────────────────────────────────────────────────────────────────
// Users
// ─────────────────────────────────────────────────────────────────

export const clientTeamGetUsers = async ({
	search,
	role,
	teamId,
	page = 1,
	limit = 100,
} = {}) => {
	// axios drops params that are `undefined`, so it's safe to pass these
	// straight through even when a filter isn't active.
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/team/users`,
		params: { search, role, teamId, page, limit },
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamInviteUser = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/team/users/invite`,
		data,
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamResendInvite = async (id) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/team/users/${id}/resend-invite`,
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamEditUser = async (id, data) => {
	const response = await axios({
		method: "PUT",
		url: `${base}/api/client/team/users/${id}`,
		data,
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamRemoveUser = async (id) => {
	const response = await axios({
		method: "DELETE",
		url: `${base}/api/client/team/users/${id}`,
		headers: authHeaders(),
	});
	return response;
};

// Public endpoint — no Authorization header. Called from the
// /accept-invite page (reads `token` from the invite-link query string).
export const clientTeamAcceptInvite = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/team/accept-invite`,
		data,
	});
	return response;
};

// ─────────────────────────────────────────────────────────────────
// Teams
// ─────────────────────────────────────────────────────────────────

export const clientTeamGetTeams = async () => {
	// No pagination on this endpoint — always returns every team.
	const response = await axios({
		method: "GET",
		url: `${base}/api/client/team/teams`,
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamCreateTeam = async (data) => {
	const response = await axios({
		method: "POST",
		url: `${base}/api/client/team/teams`,
		data,
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamEditTeam = async (id, data) => {
	const response = await axios({
		method: "PUT",
		url: `${base}/api/client/team/teams/${id}`,
		data,
		headers: authHeaders(),
	});
	return response;
};

export const clientTeamDeleteTeam = async (id) => {
	const response = await axios({
		method: "DELETE",
		url: `${base}/api/client/team/teams/${id}`,
		headers: authHeaders(),
	});
	return response;
};